import React from 'react'

import { Box, Paper, Tab, Tabs } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { useAwesomeBarContext } from '../AwesomeBarContext'
import { ALL } from '../constants'

interface IBasicProps {
  children: React.ReactNode
  [key: string]: any
}

const CloseScrim = () => {
  const { onCloseResults } = useAwesomeBarContext()
  return (
    <Box
      position="fixed"
      left={0}
      top="76px"
      width="100%"
      height="100%"
      zIndex={-1}
      tabIndex={0}
      onFocus={onCloseResults}
    />
  )
}

const useStyles = makeStyles((theme) => ({
  tab: {
    minWidth: '80px',
  },
  empty: {
    '&:empty': {
      padding: '16px',
      color: theme.palette.text.secondary,
    },
    '&:empty:before': {
      content: `attr(data-emptymessage)`,
    },
  },
  badge: {
    right: 15,
    top: 10,
  },
}))

/*
 * This is the component that displays the tabs that control the result type.
 */
const ResultTypeControls = () => {
  const { onChangeResultType, showTabs, resultTypeIndex, tabLabels } = useAwesomeBarContext()
  const classes = useStyles()

  if (!showTabs) {
    return null
  }

  return (
    <Tabs
      value={resultTypeIndex}
      onChange={(_e, idx) => {
        onChangeResultType(tabLabels[idx])
      }}
      indicatorColor="primary"
      textColor="primary"
      variant="scrollable"
      scrollButtons="auto"
      aria-label="search result tabs"
    >
      {tabLabels.map((label: string, idx: number) => {
        return (
          <Tab
            key={label}
            label={label}
            classes={{ root: classes.tab }}
            tabIndex={0}
            onFocus={function (e) {
              if (idx !== resultTypeIndex) {
                e.target.click()
              }
            }}
            id={`scrollable-auto-tab-${idx}`}
            aria-controls={`scrollable-auto-tabpanel-${idx}`}
          />
        )
      })}
    </Tabs>
  )
}

export const getEmptyMessageString = (resultType: string, getEmptyMessage?: (str: string) => string) => {
  if (getEmptyMessage) {
    return getEmptyMessage(resultType)
  }
  const str = resultType === ALL ? 'results' : resultType.toLowerCase()
  return `No ${str} found`
}

/**
 * This is the component that wraps the results of the autocomplete.
 */
export const Results: any = ({ children, ...rest }: IBasicProps) => {
  const { resultType, getEmptyMessage } = useAwesomeBarContext()
  const classes = useStyles()

  return (
    <Paper
      elevation={8}
      {...rest}
    >
      <ResultTypeControls />
      <div
        className={classes.empty}
        data-emptymessage={getEmptyMessageString(resultType, getEmptyMessage)}
      >
        {children}
      </div>
      <CloseScrim />
    </Paper>
  )
}

export default Results
